import { PayloadAction } from '@reduxjs/toolkit'
import { put } from 'redux-saga/effects'
import {
  setOrderStartDates,
  setOrderEndDates,
  setOrderProductVariants,
  setOrderNumberOfPeople,
  setContactOfRepresentative,
  setOrderPurpose,
  setOrderSaleOfGoods,
  setOrderEntryFee,
  setOrderCalendar,
  setOrderRate,
  resetOrderInput,
} from 'store/features/booking/OrderCreateInput'
import {
  OrderCreateInputType,
  OrderRateInputType,
  OrderVariantInputType,
} from 'lib/types/custom'
import {
  CalendarInput,
  ContactOfRepresentativeInput,
  OrderPurpose,
} from 'lib/graphql/storefront'

export function* updateOrderStartDates(
  payload: PayloadAction<string>
): Generator {
  try {
    yield put(setOrderStartDates(payload.payload))
  } catch (e) {
    console.log(e)
  }
}

export function* updateOrderEndDates(
  payload: PayloadAction<string>
): Generator {
  try {
    yield put(setOrderEndDates(payload.payload))
  } catch (e) {
    console.log(e)
  }
}

export function* updateOrderProductVariants(
  payload: PayloadAction<OrderVariantInputType[]>
): Generator {
  try {
    yield put(setOrderProductVariants(payload.payload))
  } catch (e) {
    console.log(e)
  }
}

export function* resetOrderProductVariants(
  payload: PayloadAction<OrderVariantInputType[]>
): Generator {
  try {
    yield put(setOrderProductVariants([]))
  } catch (e) {
    console.log(e)
  }
}

export function* updateOrderNumberOfPeople(
  payload: PayloadAction<number>
): Generator {
  try {
    yield put(setOrderNumberOfPeople(payload.payload))
  } catch (e) {
    console.log(e)
  }
}

export function* updateOrderContactOfRepresentative(
  payload: PayloadAction<ContactOfRepresentativeInput>
): Generator {
  try {
    yield put(setContactOfRepresentative(payload.payload))
  } catch (e) {
    console.log(e)
  }
}

export function* updateOrderPurpose(
  payload: PayloadAction<OrderPurpose>
): Generator {
  try {
    yield put(setOrderPurpose(payload.payload))
  } catch (e) {
    console.log(e)
  }
}

export function* updateOrderSaleOfGoods(
  payload: PayloadAction<boolean>
): Generator {
  try {
    yield put(setOrderSaleOfGoods(payload.payload))
  } catch (e) {
    console.log(e)
  }
}

export function* updateOrderEntryFee(
  payload: PayloadAction<boolean>
): Generator {
  try {
    yield put(setOrderEntryFee(payload.payload))
  } catch (e) {
    console.log(e)
  }
}

export function* updateOrderCalendar(
  payload: PayloadAction<CalendarInput>
): Generator {
  try {
    yield put(setOrderCalendar(payload.payload))
  } catch (e) {
    console.log(e)
  }
}

export function* updateOrderRate(
  payload: PayloadAction<OrderRateInputType>
): Generator {
  try {
    yield put(setOrderRate(payload.payload))
  } catch (e) {
    console.log(e)
  }
}

export function* resetOrderCreateInput(
  payload: PayloadAction<OrderCreateInputType>
): Generator {
  try {
    yield put(resetOrderInput(payload.payload))
  } catch (e) {
    console.log(e)
  }
}
